import React from 'react';
import Navbar from '../global-components/navbar';
import PageHeader from '../global-components/page-header';
import PropertySection from '../section-components/property';
import TopAuthor from '../section-components/top-author';
import Footer from '../global-components/footer';
import AreasSection from './areas-section';

const Areas = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Property" />
        <AreasSection />
        <TopAuthor />
        <Footer />
       
    </div>
}

export default Areas